import React from 'react';

export default function Kicker({ children, className = '' }) {
  return (
    <div className={`kicker ${className}`.trim()}>
      <span className="line" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
